import { render, staticRenderFns } from "./RecordCard.vue?vue&type=template&id=2d36d8da&"
import script from "./RecordCard.vue?vue&type=script&lang=ts&"
export * from "./RecordCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports